import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { SwipeContext } from './context.js';

const SwipeGroup = ({ children }) => {
    const closeFuncsRef = useRef({});
    const valueRef = useRef({
        register: (id, closeFunc) => {
            closeFuncsRef.current[id] = closeFunc;
        },
        onShown: (activeId) => {
            Object.entries(closeFuncsRef.current)
                .filter(([id]) => id !== activeId)
                .forEach(([, closeFunc]) => closeFunc());
        },
    });
    return jsx(SwipeContext.Provider, { value: valueRef.current, children: children });
};

export { SwipeGroup };
//# sourceMappingURL=SwipeGroup.js.map
